
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Comment créer une campagne Instagram Ads performante ?",
    description:
      "Découvrez comment concevoir une campagne Instagram Ads performante grâce à ce guide complet proposé par l’agence ALEO. Maximisez vos résultats publicitaires !",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
